import { render, staticRenderFns } from "./class_student_detail.vue?vue&type=template&id=76959fd9&scoped=true"
import script from "./class_student_detail.vue?vue&type=script&lang=js"
export * from "./class_student_detail.vue?vue&type=script&lang=js"
import style0 from "../assets/styles/class-student-detail.scss?vue&type=style&index=0&id=76959fd9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76959fd9",
  null
  
)

export default component.exports